import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router';
import Request from '../Request/Request';
import Store from '../Store/Store';
import Input from './Input';
import Logo from './Logo';

export default function SignIn( props ) {

	const [ data, setData ] = useState( { email:'', password:'' } )
	const inputProps = { data, setData }
	const navigate = useNavigate()

	return (
		<div style={{
			position:'fixed', left:0, top:0, width:'100%', height:'100%', 
			zIndex:100, //background:'linear-gradient( #000, #263238 )', 
			background:'#000', 
		}} >

			<Blobs top="50%" />

			<form 
				id="signin-form" 
				onSubmit={ 
					e => {
					    Request.post( 'login', data, 
					    	result => {
						      Store.set( 'user', result.data )
						      navigate( '/pages-update' )
						    },
					    )
						e.preventDefault()
					    return false
					}
				}
			>

			<div style={{
				position:'fixed', left:'50%', top:'50%', width:'100%', maxWidth:280, 
				transform:'translate(-50%,-50%)', textAlign:'center',
				fontSize:14, fontWeight:600, boxSizing:'border-box', 
			}} >

				<Input item="email" placeholder="user" type="text" style={{ margin:'10px 0' }} { ...inputProps } />
				<Input item="password" placeholder="Password" type="password" style={{ margin:'10px 0' }} { ...inputProps } />

				<button 
					type="submit" 
					form="signin-form" 
					style={{ 
						//all: 'unset',
						cursor:'pointer', padding:'18px 40px', margin:20, 
						border:'none', borderRadius:10, 
						fontWeight:700, fontSize:15, color:'#fff',  
						//background:'#ff6f00',
						background:'#000',
						//boxShadow:'0 4px 8px #00000088'
						//background:'linear-gradient(90deg, #0071BC, #fd176f, #0071BC)',
					}} 
				>
					Sign In
				</button>

			</div>

			</form>

			{/*
			<Logo />
			*/}

	    	<Link to="/">
				<div 
					style={{ 
						position:'fixed', display:'flex', alignItems:'center', top:0, left:0, 
				        //right:'max( 0px, calc( ( 100vw - 16 * 100vh / 9 ) / 2 ) )',  
						padding:30, color:'#fff', cursor:'pointer',
						fontSize:14, fontWeight:600, 
					}}
				>
					<div className="material-symbols-outlined">arrow_back</div>				
					<div style={{ paddingLeft:5 }} >Website</div>
				</div>
	    	</Link>


		</div>
	)
}

function Blobs( props ) {
  //return false
  return (
    <div style={{filter: 'blur(100px)', overflow:'hidden', pointerEvents: 'none', position: 'absolute', minWidth: '100%', marginTop: 0, height: '180%', top: props.top || '150%', left: '50%', transform: 'translateX(-50%) translateY(-50%)', zIndex: -1, opacity: .75 }}>
      <div style={{borderRadius: '99999px', position: 'absolute', top: '50%', left: '50%', width: '100vw', minWidth: '1000px', height: '100vh', transform: 'translate(-50%, -50%) scale(0.5)', overflow: 'hidden' }}>
        <div className="ColorBlobs_SpinningGradient__DpGtx" style={{position: 'absolute', top: '50%', left: '50%', width: '100vw', height: '100vw', transform: 'translate(-50%, -50%)' }}>
        </div>
      </div>
    </div>
  )
}
